import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

import auth from './modules/auth.store'
import customer from './modules/customer.store'
import product from './modules/product.store'
import washStation from './modules/washStation.store'
import task from './modules/task.store'
import worker from './modules/worker.store'
import invoice from './modules/invoice.store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const dataState = new createPersistedState({
  paths: ['auth']
})

export default new Vuex.Store({
  modules: {
    auth,
    customer,
    product,
    washStation,
    task,
    worker,
    invoice,
  },
  plugins: [dataState],
  strict: debug,
})
